import { http } from '../../config/axios'

export default function patchNotaFiscalCancelar(id: string): Promise<any> {
  return http
    .patch('api/nota-fiscal/cancelar/' + id)
    .then((res) => {
      return res.data
    })
    .catch((error) => {
      console.error('Erro ao cancelar nota fiscal', error)
      throw Error(error.response?.data || 'Erro ao cancelar nota fiscal')
    })
}
